import { render, staticRenderFns } from "./InformesGeneradosPantalla.vue?vue&type=template&id=d5f1fa94&scoped=true&"
import script from "./InformesGeneradosPantalla.vue?vue&type=script&lang=ts&"
export * from "./InformesGeneradosPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./InformesGeneradosPantalla.vue?vue&type=style&index=0&id=d5f1fa94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f1fa94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d5f1fa94', component.options)
    } else {
      api.reload('d5f1fa94', component.options)
    }
    module.hot.accept("./InformesGeneradosPantalla.vue?vue&type=template&id=d5f1fa94&scoped=true&", function () {
      api.rerender('d5f1fa94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/InformesGenerados/InformesGeneradosPantalla.vue"
export default component.exports